/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Nudge_DescInputs */

const en_ui_studio_nudge_desc = /** @type {(inputs: Ui_Studio_Nudge_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import a GPX route to preview it on the map before you head out`)
};

const de_ui_studio_nudge_desc = /** @type {(inputs: Ui_Studio_Nudge_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importiere eine GPX-Route und sieh sie dir auf der Karte an, bevor es losgeht`)
};

/**
* | output |
* | --- |
* | "Import a GPX route to preview it on the map before you head out" |
*
* @param {Ui_Studio_Nudge_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_nudge_desc = /** @type {((inputs?: Ui_Studio_Nudge_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Nudge_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_nudge_desc(inputs)
	return de_ui_studio_nudge_desc(inputs)
});